/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ELoginResponseStatus } from './ELoginResponseStatus';
import {
    ELoginResponseStatusFromJSON,
    ELoginResponseStatusFromJSONTyped,
    ELoginResponseStatusToJSON,
    ELoginResponseStatusToJSONTyped,
} from './ELoginResponseStatus';
import type { LoginResponseUserBody } from './LoginResponseUserBody';
import {
    LoginResponseUserBodyFromJSON,
    LoginResponseUserBodyFromJSONTyped,
    LoginResponseUserBodyToJSON,
    LoginResponseUserBodyToJSONTyped,
} from './LoginResponseUserBody';

/**
 * 
 * @export
 * @interface LoginResponseUserBodyLoginResponseDto
 */
export interface LoginResponseUserBodyLoginResponseDto {
    /**
     * 
     * @type {ELoginResponseStatus}
     * @memberof LoginResponseUserBodyLoginResponseDto
     */
    status: ELoginResponseStatus;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseUserBodyLoginResponseDto
     */
    message?: string | null;
    /**
     * 
     * @type {LoginResponseUserBody}
     * @memberof LoginResponseUserBodyLoginResponseDto
     */
    body?: LoginResponseUserBody;
}



/**
 * Check if a given object implements the LoginResponseUserBodyLoginResponseDto interface.
 */
export function instanceOfLoginResponseUserBodyLoginResponseDto(value: object): value is LoginResponseUserBodyLoginResponseDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function LoginResponseUserBodyLoginResponseDtoFromJSON(json: any): LoginResponseUserBodyLoginResponseDto {
    return LoginResponseUserBodyLoginResponseDtoFromJSONTyped(json, false);
}

export function LoginResponseUserBodyLoginResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponseUserBodyLoginResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': ELoginResponseStatusFromJSON(json['status']),
        'message': json['message'] == null ? undefined : json['message'],
        'body': json['body'] == null ? undefined : LoginResponseUserBodyFromJSON(json['body']),
    };
}

export function LoginResponseUserBodyLoginResponseDtoToJSON(json: any): LoginResponseUserBodyLoginResponseDto {
    return LoginResponseUserBodyLoginResponseDtoToJSONTyped(json, false);
}

export function LoginResponseUserBodyLoginResponseDtoToJSONTyped(value?: LoginResponseUserBodyLoginResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ELoginResponseStatusToJSON(value['status']),
        'message': value['message'],
        'body': LoginResponseUserBodyToJSON(value['body']),
    };
}

